module.exports = __webpack_public_path__ + "static/media/heart-filled.5ad84c4b.svg";